import { Injectable } from '@angular/core';
import { ActionsSubject, Store } from '@ngrx/store';
import * as AuthActions from '../actions/auth.actions';
import * as AuthApiActions from '../actions/auth-api.actions';
import * as SignInActions from '../actions/signin-page.actions';
import * as AuthReducer from '../reducers';
import { Credentials } from '../../../auth/model/user';
import { ofType } from '@ngrx/effects';
import { ResetPassword } from '../../../auth/model/reset-password';

@Injectable({
  providedIn: 'root'
})
export class AuthFacade {
  public getUser$ = this._store.select(AuthReducer.getUser);
  public getLoggedIn$ = this._store.select(AuthReducer.getLoggedIn);
  public hasPrivilege$ = (privilege: string) => this._store.select(AuthReducer.hasPrivilege, privilege);
  public getSigninPageError$ = this._store.select(AuthReducer.getSigninPageError);
  public getSigninPagePending$ = this._store.select(AuthReducer.getSigninPagePending);
  public forgotPasswordSuccess$ = this._actionsSubj.pipe(ofType(AuthApiActions.forgotPasswordSuccess.type));
  public forgotPasswordFailure$ = this._actionsSubj.pipe(ofType(AuthApiActions.forgotPasswordFailure.type));
  public resetPasswordSuccess$ = this._actionsSubj.pipe(ofType(AuthApiActions.resetPasswordSuccess.type));
  public resetPasswordFailure$ = this._actionsSubj.pipe(ofType(AuthApiActions.resetPasswordFailure.type));

  constructor(
    private _store: Store<any>,
    private _actionsSubj: ActionsSubject,
  ) { }


  // Auth
  public logout() {
    this._store.dispatch(AuthActions.logout());
  }
  public updateToken(token: string) {
    this._store.dispatch(AuthActions.updateToken({token}));
  }
  public setUser(token: string, language: string) {
    this._store.dispatch(AuthActions.setUser({token, language}));
  }
  public changeUserLanguage(language: string) {
    this._store.dispatch(AuthActions.changeUserLanguage({language}));
  }
  public loginRedirect(url: string) {
    this._store.dispatch(AuthApiActions.loginRedirect({url}));
  }
  public forgotPassword(userName: string) {
    this._store.dispatch(AuthActions.forgotPassword({userName}));
  }
  public resetPassword(data: ResetPassword) {
    this._store.dispatch(AuthActions.resetPassword({data}));
  }

  // SignIn
  public signin(credentials: Credentials, url: string) {
    this._store.dispatch(SignInActions.signin({credentials, url}));
  }
  public autoLogin(url: string) {
    this._store.dispatch(SignInActions.autoLogin({url}));
  }
  public autoLogout() {
    this._store.dispatch(SignInActions.autoLogout());
  }

}
